// const baseURL = "https://intellettualinfuga.com/api"; 
/* const baseURL = "http://192.168.0.23:3001"; */
const baseURL = process.env.REACT_APP_API_URL;
export default baseURL;